export default __webpack_public_path__ + "static/char-v-38-f4329e3b7ee32d5792b1305de8bd42b8.png";